import script from "./SettingsIntegrations.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsIntegrations.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import ConnectedAppsCard from "@/components/settings/ConnectedAppsCard.vue";
import ParsleyConnectionCard from "@/components/parsley/ParsleyConnectionCard.vue";
import PaytronixCard from "@/components/settings/PaytronixCard.vue";
import SettingsSection from "@/components/neue/SettingsSection.vue";
script.components = Object.assign({}, { ConnectedAppsCard, ParsleyConnectionCard, PaytronixCard, SettingsSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ConnectedAppsCard, ParsleyConnectionCard, PaytronixCard, SettingsSection }, script.__o.components);}